import { NAMESPACE } from './constants';

const MOBILE_LOG_LINE_ADD = `${NAMESPACE}/MOBILE_LOG_LINE_ADD`;
const MOBILE_LOG_LINES_LOAD_MORE = `${NAMESPACE}/MOBILE_LOG_LINES_LOAD_MORE`;
const MOBILE_LOG_LINES_PAUSE = `${NAMESPACE}/MOBILE_LOG_LINES_PAUSE`;
const MOBILE_LOG_LINES_RESUME = `${NAMESPACE}/MOBILE_LOG_LINES_RESUME`;
const MOBILE_LOG_SET_LOG_LEVEL = `${NAMESPACE}/MOBILE_LOG_SET_LOG_LEVEL`;
const MOBILE_LOG_CLEAR = `${NAMESPACE}/MOBILE_LOG_CLEAR`;
const MOBILE_LOG_UPDATE_DISPLAYED_LINES = `${NAMESPACE}/MOBILE_LOG_UPDATE_DISPLAYED_LINES`;
const MOBILE_LOG_UPDATE_FILTERS = `${NAMESPACE}/MOBILE_LOG_UPDATE_FILTERS`;
const MOBILE_LOG_DOWNLOAD_LOG = `${NAMESPACE}/MOBILE_LOG_DOWNLOAD_LOG`;
const MOBILE_LOG_EXPAND_SEARCH = `${NAMESPACE}/MOBILE_LOG_EXPAND_SEARCH`;
const MOBILE_LOG_WRAP_TEXT = `${NAMESPACE}/MOBILE_LOG_WRAP_TEXT`;
const MOBILE_LOG_CHANGE_APP = `${NAMESPACE}/MOBILE_LOG_CHANGE_APP`;
const MOBILE_LOG_UPDATE_SESSION = `${NAMESPACE}/MOBILE_LOG_UPDATE_SESSION`;

export default {
  MOBILE_LOG_LINE_ADD,
  MOBILE_LOG_LINES_LOAD_MORE,
  MOBILE_LOG_LINES_PAUSE,
  MOBILE_LOG_LINES_RESUME,
  MOBILE_LOG_SET_LOG_LEVEL,
  MOBILE_LOG_CLEAR,
  MOBILE_LOG_UPDATE_DISPLAYED_LINES,
  MOBILE_LOG_UPDATE_FILTERS,
  MOBILE_LOG_DOWNLOAD_LOG,
  MOBILE_LOG_EXPAND_SEARCH,
  MOBILE_LOG_WRAP_TEXT,
  MOBILE_LOG_CHANGE_APP,
  MOBILE_LOG_UPDATE_SESSION,
};
